<div style="position: relative;">
  <div #detailedView [ngClass]="{ 'scrollable-table': isScrollableForContent }"  id="assetAllocationTableExportDiv">
      <table scrollingTable aria-label="DetailedView">
          <thead [ngClass]="{'sticky-header': !isScrollableForContent, 'mobile-header': isScrollableForContent}">
            <tr *ngIf="filterBy && !(filterBy =='non-vanguard-mutual-funds')">
                  <th style="width: 208px;" class="border-right-white" [ngClass]="{'spacing' : !openFilter,'spacing-filter' : openFilter, 'mobile-detail': openFilter }" scope="col"></th>
                  <th style="width: 100px" class="border-right-white" scope="col"></th>
                  <th style="width: 70px"  class="border-right-white" scope="col"></th>
                  <th  class="border-right-white" scope="col"></th>
                  <th *ngIf="filterBy && !(filterBy =='529-portfolios')" class="border-right-white" scope="col"></th>
                  <th *ngIf="filterBy && !(filterBy =='529-portfolios')" class="border-right-white" scope="col"></th>
                  <th   class="border-right-white" scope="col"></th>
                  <th class="border-right-white align-right" scope="col">
                      <p class="rps-paragraph-three" style="
                      margin-top: 15px;
                      ">As of</p>
                      <p class="rps-paragraph-three" data-rpa-tag-id="ytdDate">
                        {{ ytdAsOfDate ? (ytdAsOfDate | ESTPipe) : '&mdash;'}}</p>
                    </th>
                    <th colspan=4 scope="col" class="align-center">
                      <p class="rps-paragraph-three" data-rpa-tag-id="performanceDate">Average annual
                        returns as of {{annualReturnsDate ? (annualReturnsDate | ESTPipe) : '&mdash;'}}</p>
                    </th>
                    <th class="border-right-white" scope="col"></th>
                    <th  class="border-right-white no-padding" colspan=2 scope="col">
                      <div  class="align-center buttons-svg" *ngIf='!disableSwitch'>
                        <button [ngClass]="!switchModel ? 'black-color-nav' : 'white-color-nav'" aria-label="Price Toggle NAV"  (click)="changePriceToggle('NAV')"></button>
                        <button [ngClass]="!switchModel ?  'white-color-market' : 'black-color-market' " aria-label="Price Toggle Market"  (click)="changePriceToggle('Market')"></button>
                         </div>
                      <p style="top: 2px; position: relative; padding-right: 10px;" class="align-center rps-paragraph-three rps-black" data-rpa-tag-id="priceChangeDate">As of {{priceAsOfDate ? (priceAsOfDate | ESTPipe) : '&mdash;'}}</p>
                    </th>
                </tr>

              <tr *ngIf="filterBy && (filterBy =='non-vanguard-mutual-funds')">
                  <th style="width: 100px" class="border-right-white" scope="col"></th>
                  <!-- <th style="width: 70px"  class="border-right-white" scope="col"></th>
                  <th  class="border-right-white" scope="col"></th> -->
                  <!-- <th *ngIf="filterBy && !(filterBy =='529-portfolios')" class="border-right-white" scope="col"></th>-->
                  <th *ngIf="filterBy && !(filterBy =='529-portfolios')" class="border-right-white" scope="col"></th>
                  <th   class="border-right-white" scope="col"></th>
                  <th class="border-right-white align-right" scope="col">
                      <p class="rps-paragraph-three rps-grey" style="
                      margin-top: 15px;
                      ">As of</p>
                      <p class="rps-paragraph-three rps-grey" data-rpa-tag-id="ytdDate">
                        {{ ytdAsOfDate ? (ytdAsOfDate | ESTPipe) : '&mdash;'}}</p>
                    </th>
                    <th colspan=4 scope="col" class="border-right-white align-center">
                      <p class="rps-paragraph-three rps-grey" data-rpa-tag-id="performanceDate">Average annual
                        returns as of {{annualReturnsDate ? (annualReturnsDate | ESTPipe) : '&mdash;'}}</p>
                    </th>
                    <!-- <th class="border-right-white" scope="col"></th> -->
                    <th  class="border-right-white no-padding" colspan=2 scope="col">
                      <div  class="align-center buttons-svg" *ngIf='!disableSwitch'>
                        <button [ngClass]="!switchModel ? 'black-color-nav' : 'white-color-nav'" aria-label="Price Toggle NAV"  (click)="changePriceToggle('NAV')"></button>
                        <button [ngClass]="!switchModel ?  'white-color-market' : 'black-color-market' " aria-label="Price Toggle Market"  (click)="changePriceToggle('Market')"></button>
                         </div>
                      <p style="top: 2px;position: relative;" class="align-center rps-paragraph-three rps-grey" data-rpa-tag-id="priceChangeDate">As of {{priceAsOfDate ? (priceAsOfDate | ESTPipe) : '&mdash;'}}</p>
                     </th>
              </tr>


              <tr>
                  <th [ngStyle]="(filterBy && filterBy === 'non-vanguard-mutual-funds') ? {'width': '250px'} : {'width' : '208px'}" class="border-right-white" scope="col">
                      <span *ngIf="!data[0]?.profile?.is529">
                        <p class="rps-paragraph-two" [ngClass]="{'selected-column': sortColumn ==='ticker'}">Symbol
                        </p>
                        <VFA-sort-by initialColumn='ticker' [sortDirection]='sortDirection'
                            [sortColumn]='sortColumn' [fullData]='fullData' [pageNumber]='pageNumber'
                            (changeTabData)="updateSortData($event)">
                        </VFA-sort-by>
                        <span style="color: #CBCECE">&nbsp;|&nbsp;</span>
                    </span>

                      <p class="rps-paragraph-two" style="position: relative;" [ngClass]="{'selected-column': sortColumn ==='fundName'}">Name</p>
                      <VFA-sort-by style="position: relative;" initialColumn='fundName' [sortDirection]='sortDirection' [sortColumn]='sortColumn'
                          [fullData]='fullData' [pageNumber]='pageNumber' (changeTabData)="updateSortData($event)">
                      </VFA-sort-by>

                  </th>
                  <th style="width: 100px; padding:0 5px 0 5px;" class="border-right-white align-asset-class"  scope="col">
                      <p class="rps-paragraph-two rps-mark-narrow" [ngClass]="{'selected-column': sortColumn ==='assetClass'}">Asset class</p>
                      <VFA-sort-by initialColumn='assetClass' [sortDirection]='sortDirection'
                          [sortColumn]='sortColumn' [fullData]='fullData' [pageNumber]='pageNumber'
                          (changeTabData)="updateSortData($event)">
                      </VFA-sort-by>
                  </th>
                  <th *ngIf="filterBy && !(filterBy =='non-vanguard-mutual-funds')" style="width: 70px" class="border-right-white align-center" scope="col">
                      <p class="rps-paragraph-two rps-mark-narrow" [ngClass]="{'selected-column': sortColumn ==='risk'}">Risk</p>
                      <VFA-sort-by initialColumn='risk' [sortDirection]='sortDirection' [sortColumn]='sortColumn'
                          [fullData]='fullData' [pageNumber]='pageNumber' (changeTabData)="updateSortData($event)">
                      </VFA-sort-by>
                  </th>
                  <th *ngIf="filterBy && !(filterBy =='non-vanguard-mutual-funds')" class="border-right-white"  scope="col">
                     <p class="rps-paragraph-two rps-mark-narrow" [ngClass]="sortColumn ==='expenseRatio' ? 'selected-column' : 'inline-block'"
                      style="position: relative; top: -10px;">
                      <a href="javascript:void(0)" role="button" class="dialog-link" aria-label="expenseRatioLink"
                      (click)="setDialogInfo('Expense ratio');detailViewModalDialog.openModalDialog();">
                      Expense <br>ratio
                  </a>
                    </p>
                      <VFA-sort-by style="position: relative; top: -10px;" initialColumn='expenseRatio' [sortDirection]='sortDirection'
                          [sortColumn]='sortColumn' [fullData]='fullData' [pageNumber]='pageNumber'
                          (changeTabData)="updateSortData($event)">
                      </VFA-sort-by>
                  </th>

                  <th   *ngIf="filterBy && !(filterBy =='529-portfolios') && !(filterBy =='non-vanguard-mutual-funds')" class=" border-right-white compare-cell-col align-center" scope="col">
                      <p class="rps-paragraph-two  rps-mark-narrow compare-cell">
                        <a href="javascript:void(0)" role="button" class="dialog-link"
                        (click)="setDialogInfo('Comparison of funds');detailViewModalDialog.openModalDialog();">
                        Compare
                        </a>
                      </p>
                    </th>

                    <th  *ngIf="filterBy && !(filterBy =='529-portfolios') && !(filterBy =='non-vanguard-mutual-funds')" class=" border-right-white compare-cell-col align-center" scope="col">
                      <p class="rps-paragraph-two rps-mark-narrow  compare-cell">
                        Transact

                      </p>
                    </th>

                  <th class="border-right-white" [ngStyle]="(filterBy && filterBy === 'non-vanguard-mutual-funds') && {'width': '100px', 'padding-top': '21px'}" scope="col">
                      <p class="rps-paragraph-two rps-mark-narrow" [ngClass]="sortColumn ==='secYield' ? 'selected-column' : 'inline-block'"
                      style="position: relative; top: -10px;">
                      <a *ngIf="filterBy && (filterBy =='non-vanguard-mutual-funds')" href="javascript:void(0)" role="button" class="dialog-link" aria-label="SEC yield dialog title"
                      (click)="setDialogInfo('SEC yield');detailViewModalDialog.openModalDialog();">SEC yield</a>
                      <a *ngIf="filterBy && !(filterBy =='non-vanguard-mutual-funds')" href="javascript:void(0)" role="button" class="dialog-link" aria-label="SEC yield dialog title"
                      (click)="setDialogInfo('SEC yield');detailViewModalDialog.openModalDialog();">SEC <br>yield</a>
                    </p>
                      <VFA-sort-by style="position: relative; top: -10px; padding-right: 4px;" initialColumn='secYield' [sortDirection]='sortDirection' [sortColumn]='sortColumn'
                        [fullData]='fullData' [pageNumber]='pageNumber' (changeTabData)="updateSortData($event)"></VFA-sort-by>
                    </th>

                    <th class="border-right-white" [ngStyle]="(filterBy && filterBy === 'non-vanguard-mutual-funds') && {'width': '8%'}" scope="col">
                      <p class="rps-paragraph-two rps-mark-narrow" [ngClass]="{'selected-column': sortColumn ==='ytd'}">YTD</p>
                      <VFA-sort-by  style="padding-right: 4px;" initialColumn='ytd' [sortDirection]='sortDirection' [sortColumn]='sortColumn'
                        [fullData]='fullData' [pageNumber]='pageNumber' (changeTabData)="updateSortData($event)"></VFA-sort-by>
                    </th>
                    <th scope="col">
                      <p class="rps-paragraph-two rps-mark-narrow" [ngClass]="{'selected-column': sortColumn ==='1-yr'}">1-yr</p>
                      <VFA-sort-by initialColumn='1-yr' [sortDirection]='sortDirection' [sortColumn]='sortColumn'
                        [fullData]='fullData' [pageNumber]='pageNumber' (changeTabData)="updateSortData($event)"></VFA-sort-by>
                    </th>
                    <th scope="col">
                      <p class="rps-paragraph-two rps-mark-narrow" [ngClass]="{'selected-column': sortColumn ==='5-yr'}">5-yr</p>
                      <VFA-sort-by initialColumn='5-yr' [sortDirection]='sortDirection' [sortColumn]='sortColumn'
                        [fullData]='fullData' [pageNumber]='pageNumber' (changeTabData)="updateSortData($event)"></VFA-sort-by>
                    </th>
                    <th scope="col">
                      <p class="rps-paragraph-two rps-mark-narrow" [ngClass]="{'selected-column': sortColumn ==='10-yr'}">10-yr</p>
                      <VFA-sort-by initialColumn='10-yr' [sortDirection]='sortDirection' [sortColumn]='sortColumn'
                        [fullData]='fullData' [pageNumber]='pageNumber' (changeTabData)="updateSortData($event)"></VFA-sort-by>
                    </th>

                    <th [ngClass]="{'border-right-white' : (filterBy && (filterBy =='non-vanguard-mutual-funds'))}" scope="col">
                      <p class="rps-paragraph-two rps-mark-narrow" [ngClass]="{'selected-column': sortColumn ==='sinceInception'}" style="position: relative; top: -10px;">
                        Since <br>inception</p>
                      <VFA-sort-by style="position: relative; top: -10px;" [ngClass]="{'since-inception-nvmf' : (filterBy && filterBy === 'non-vanguard-mutual-funds')}" initialColumn='sinceInception'
                        [sortDirection]='sortDirection' [sortColumn]='sortColumn' [fullData]='fullData' [pageNumber]='pageNumber'
                        (changeTabData)="updateSortData($event)"></VFA-sort-by>
                    </th>

                    <th *ngIf="filterBy && !(filterBy =='non-vanguard-mutual-funds')" class="border-right-white"  scope="col">
                      <p class="rps-paragraph-two rps-mark-narrow" [ngClass]="sortColumn ==='investmentMinimum' ? 'selected-column' : 'inline-block'"
                        style="position: relative; top: -10px;">
                        <a href="javascript:void(0)" role="button" class="dialog-link" aria-label="investmentMinimumLink"
                          (click)="setDialogInfo('Investment Minimum');detailViewModalDialog.openModalDialog();">Investment <br>Minimum</a>
                      </p>
                      <VFA-sort-by  initialColumn='investmentMinimum' [sortDirection]='sortDirection' [sortColumn]='sortColumn'
                        [fullData]='fullData' [pageNumber]='pageNumber' (changeTabData)="updateSortData($event)"
                        style="position: relative; top: -10px;padding-right: 4px;"></VFA-sort-by>
                    </th>
                    <th style="padding-left: 15px" scope="col" *ngIf="filterBy && !(filterBy =='529-portfolios')">
                      <p class="rps-paragraph-two inline-block mark-pro-regular rps-mark-narrow"
                        [ngClass]="sortColumn ==='price' ? 'selected-column' : 'inline-block'">
                        <a *ngIf="(switchModel)" href="javascript:void(0)" role="button" class="dialog-link" aria-label="priceDialogLink"
                                                  (click)="setDialogInfo('Price');detailViewModalDialog.openModalDialog();">Price</a>
                                                  <span *ngIf="!(switchModel)">Price</span>
                      </p>
                      <VFA-sort-by initialColumn='price' [switchModel]='switchModel' [sortDirection]='sortDirection'
                        [sortColumn]='sortColumn' [fullData]='fullData' [pageNumber]='pageNumber'
                        (changeTabData)="updateSortData($event)"></VFA-sort-by>
                    </th>
                    <th scope="col" *ngIf="filterBy && (filterBy =='529-portfolios')">
                      <p class="rps-paragraph-two rps-mark-narrow" [ngClass]="sortColumn ==='unitPrice' ? 'selected-column' : 'inline-block'">
                        <a href="javascript:void(0)" role="button" class="dialog-link" aria-label="unitPriceDialogLink"
                          (click)="setDialogInfo('Unit Price');detailViewModalDialog.openModalDialog();">Unit Price</a>
                      </p>
                      <VFA-sort-by initialColumn='unitPrice' [sortDirection]='sortDirection' [sortColumn]='sortColumn'
                        [fullData]='fullData' [pageNumber]='pageNumber' (changeTabData)="updateSortData($event)"></VFA-sort-by>
                    </th>
                    <th scope="col"  class="border-right-white">
                      <p class="rps-paragraph-two rps-mark-narrow" [ngClass]="sortColumn ==='changePrice' ? 'selected-column' : 'inline-block'">Change</p>
                      <VFA-sort-by [ngClass]="{'pricechange-nvmf' : (filterBy && filterBy === 'non-vanguard-mutual-funds')}" initialColumn='changePrice' [switchModel]='switchModel' [sortDirection]='sortDirection'
                        [sortColumn]='sortColumn' [fullData]='fullData' [pageNumber]='pageNumber'
                        (changeTabData)="updateSortData($event)"></VFA-sort-by>
                    </th>

              </tr>
          </thead>
          <tbody>
              <ng-container *ngIf="(loading$ | async); then loading else results"></ng-container>
              <ng-container *ngIf="data.length == 0 && !(loading$ | async); then noData"></ng-container>
          </tbody>
      </table>
  </div>

</div>

<ng-template #results>
  <tr *ngFor="let fund of data; let i= index" [attr.data-rpa-tag-id]="(fund.profile?.ticker) || (fund.profile?.is529 ? fund.profile?.fundId :  fund.profile?.longName)">
      <th [ngStyle]="(filterBy && filterBy === 'non-vanguard-mutual-funds') ? {'width': '250px'} : {'width': '208px'}" [ngClass]="(advisedBanner(fund.profile.fundId) || fund.profile?.fundFact?.isClosed ||
       fund.profile?.fundFact?.isClosedToNewInvestors) ? 'padding-16' : 'padding-14'"
        scope="row">
          <p  class="rps-paragraph-one rps-mark-bold rps-mark-narrow">
            <span *ngIf="fund.profile?.ticker && (fund.profile?.isMutualFund || fund.profile?.isETF)" data-rpa-tag-id="symbol">{{fund.profile?.ticker ? fund.profile?.ticker : '&mdash;'}}<br></span>
              <a class="rps-mark-narrow" data-rpa-tag-id="longName" style="padding-bottom: 7px;"
                 href="{{profileRoot}}/{{fund.profile?.isETF? 'investment-products': fund.profile?.isMutualFund? 'investment-products': 'accounts-plans'}}/{{fund.profile?.isETF? 'etfs': fund.profile?.isMutualFund? 'mutual-funds': '529-plans'}}/profile/{{fund.profile?.is529?fund.profile?.fundId:fund.profile?.ticker | lowercase}}">
                      {{fund.profile?.longName.replace('Vanguard ', '')}}
                      {{fund.profile?.fundFact?.isNTFFund===true? ' [NTF]' : ''}}
                      {{fund.profile?.fundFact?.isLoadFund===true? ' [Load]' : ''}}
                      {{fund.profile?.fundFact?.hasTransactionFee===true? ' [TF]' : ''}}
              </a>
          </p>
        <ng-container *ngIf="fund.profile?.isInternalFund">
          <p class="rps-paragraph-one rps-grey rps-FF-mark-italic" *ngIf="fund.fees?.purchaseFee?.content!='None' && !fund.profile?.isETF">
            Purchase fees: {{fund.fees?.purchaseFee?.content}}</p>
          <p class="rps-paragraph-one rps-grey rps-FF-mark-italic" *ngIf="fund.fees?.redemptionFee?.content!='None' && !fund.profile?.isETF">
            Redemption fees: {{fund.fees?.redemptionFee?.content}}</p>
        </ng-container>
          <span  *ngIf="fund.profile?.fundFact?.isClosed || fund.profile?.fundFact?.isClosedToNewInvestors"
               class="rps-paragraph-two rps-mark-bold rps-white badge badge-light margin-top">CLOSED</span>
          <span *ngIf="advisedBanner(fund.profile.fundId)"
              class="rps-paragraph-two rps-mark-bold badge badge-advised margin-top">VANGUARD ADVISED ONLY</span>
      </th>
      <td class="align-asset-class" style="width: 100px ; margin-left: 6px;">
          <p class="rps-paragraph-one rps-mark-narrow" [ngStyle]="(filterBy && filterBy === 'non-vanguard-mutual-funds') ? {'width': '170px', 'margin-left': '6px'} : {'width': '100px', 'margin-left': '6px'}"
          innerHtml="{{emDashDisplay(fund.profile?.customizedStyle)}}" data-rpa-tag-id="assetClass"></p>
      </td>
      <td *ngIf="filterBy && !(filterBy =='non-vanguard-mutual-funds')" style="width: 70px" class="risk-oval align-center">
          <p class="rps-paragraph-one rps-mark-bold" innerHtml="{{emDashDisplay(fund.risk?.code)}}"
              [ngClass]="{'riskValueOne': fund.risk?.code === 1, 'riskValueTwo': fund.risk?.code === 2,
              'riskValueThree': fund.risk?.code === 3, 'riskValueFour': fund.risk?.code === 4,
               'riskValueFive': fund.risk?.code === 5}" data-rpa-tag-id="risk">
          </p>
      </td>
      <td *ngIf="filterBy && !(filterBy =='non-vanguard-mutual-funds')">
          <p class="rps-paragraph-one rps-mark-narrow" innerHtml="{{(filterBy && filterBy === 'non-vanguard-mutual-funds'? '' : fund.profile?.expenseRatio)| percentParser}}"
          data-rpa-tag-id="expenseRatio"></p>
      </td>
      <td *ngIf="!(fund.profile?.is529 || filterBy && (filterBy =='non-vanguard-mutual-funds'))" class="align-center">
          <VFA-compare-tool-checkbox [fundInput]='fund' [comparedFunds]='comparedFunds' [fundIndex]=i></VFA-compare-tool-checkbox>
        </td>

        <td class="align-center"
        *ngIf="!(fund.profile?.fundFact?.isClosed || filterBy && (filterBy =='non-vanguard-mutual-funds') ||fund.profile?.fundFact?.isClosedToNewInvestors || fund.profile?.is529 || advisedBanner(fund.profile.fundId))" VFA-buy-button
        [fundInput]='fund.profile'></td>
        <td class="align-center"
        *ngIf="(filterBy && !(filterBy =='non-vanguard-mutual-funds')) && (fund.profile?.fundFact?.isClosed || fund.profile?.fundFact?.isClosedToNewInvestors || fund.profile?.is529 || advisedBanner(fund.profile.fundId)) && !(filterBy =='529-portfolios')" ></td>
        <td [ngStyle]="(filterBy && filterBy === 'non-vanguard-mutual-funds') && {'padding-right': '5px'}">
          <span
            *ngIf="!fund.yield?.yieldPct && fund.profile?.category !=='Real Estate'" data-rpa-tag-id="yieldPct">{{fund.yield?.yieldPct|
            percentParser}}</span>
          <span *ngIf="fund.yield?.yieldPct  && fund.profile?.category !=='Real Estate'">
            <p class="rps-paragraph-one rps-mark-narrow yieldPct">
              <a *ngIf="staticTicker.indexOf(fund.profile?.ticker)>=0" href="javascript:void(0)" role="button"
                class="dialog-link" in
                (click)="setDialogInfo(fund.profile?.longName,fund.profile?.ticker,fund.profile?.fundId);detailViewModalDialog.openModalDialog();" data-rpa-tag-id="yieldPct">{{fund.yield.yieldPct|
                percentParser}}</a>
              <span *ngIf="staticTicker.indexOf(fund.profile?.ticker)<0" data-rpa-tag-id="yieldPct">
                {{fund.yield?.yieldPct| percentParser}}</span>

              <span class="yieldNote" *ngFor="let yieldNote of fund.yield.yieldNote">
                <a href="javascript:void(0)" role="button" class="dialog-link" aria-label="footnoteCodeLink"
                  (click)="setDialogInfo(fund.profile.longName,yieldNote.footnoteText,yieldNote?.footnoteCode);detailViewModalDialog.openModalDialog();"
                  data-rpa-tag-id="yieldFootnote">{{yieldNote.footnoteCode}}</a>
              </span>
            </p>
            <p class="rps-paragraph-one rps-mark-narrow" data-rpa-tag-id="yieldText">{{createDaysToken(fund.yield?.yieldNote)}}</p>
            <p class="rps-paragraph-three rps-mark-narrow" data-rpa-tag-id="yieldDate">{{emDashDisplay(fund.yield?.asOfDate | ESTPipe)}}</p>
          </span>
          <span *ngIf="fund.profile?.category ==='Real Estate'">
            <ng-container *ngIf="filterBy === 'non-vanguard-mutual-funds'; else noteLink">
              <span data-rpa-tag-id="yieldPct">{{fund.yield?.yieldPct| percentParser}}</span>
              <p *ngIf="fund.yield?.asOfDate" class="rps-paragraph-three rps-mark-narrow" data-rpa-tag-id="yieldDate">{{emDashDisplay(fund.yield?.asOfDate | ESTPipe)}}</p>
            </ng-container>
            <ng-template #noteLink>
              <a *ngIf="fund.profile?.isETF" [attr.href]="(investorURI+etfPath+fund.profile?.ticker+secYieldPath).toLowerCase()" role="button" class="dialog-link">note</a>
              <a *ngIf="fund.profile?.isMutualFund" [attr.href]="(investorURI+mfPath+fund.profile?.ticker+secYieldPath).toLowerCase()" role="button" class="dialog-link">note</a>
            </ng-template>
          </span>
        </td>
        <td [ngStyle]="(filterBy && filterBy === 'non-vanguard-mutual-funds') && {'padding-right': '5px'}">
          <p class="rps-paragraph-one rps-mark-narrow" *ngIf="fund.profile?.isETF" data-rpa-tag-id="ytdPercent">
            {{fund.ytd?.marketPrice| percentParser}}</p>
          <p class="rps-paragraph-one rps-mark-narrow" *ngIf="fund.profile?.is529 || fund.profile?.isMutualFund"
          data-rpa-tag-id="ytdPercent">
            {{fund.ytd?.regular| percentParser}}</p>
        </td>
        <td>
          <p class="rps-paragraph-one rps-mark-narrow" *ngIf="fund.profile?.isETF" data-rpa-tag-id="oneYrPct">
            {{fund.monthEndAvgAnnualRtn?.marketPriceFundReturn?.oneYrPct| percentParser}}
          </p>
          <p class="rps-paragraph-one rps-mark-narrow" *ngIf="fund.profile?.isMutualFund || fund.profile?.is529"
          data-rpa-tag-id="oneYrPct">
          {{fund.monthEndAvgAnnualRtn?.fundReturn?.oneYrPct | percentParser}}</p>
        </td>
        <td>
          <p class="rps-paragraph-one rps-mark-narrow" *ngIf="fund.profile?.isETF" data-rpa-tag-id="fiveYrPct">
            {{fund.monthEndAvgAnnualRtn?.marketPriceFundReturn?.fiveYrPct| percentParser}}
          </p>
          <p class="rps-paragraph-one rps-mark-narrow" *ngIf="fund.profile?.isMutualFund || fund.profile?.is529" data-rpa-tag-id="fiveYrPct">
            {{fund.monthEndAvgAnnualRtn?.fundReturn?.fiveYrPct| percentParser}}
          </p>
        </td>
        <td>
          <p class="rps-paragraph-one rps-mark-narrow" *ngIf="fund.profile?.isETF" data-rpa-tag-id="tenYrPct">
            {{fund.monthEndAvgAnnualRtn?.marketPriceFundReturn?.tenYrPct| percentParser}}
          </p>
          <p class="rps-paragraph-one rps-mark-narrow" *ngIf="fund.profile?.isMutualFund || fund.profile?.is529" data-rpa-tag-id="tenYrPct">
            {{fund.monthEndAvgAnnualRtn?.fundReturn?.tenYrPct| percentParser}}
          </p>
        </td>

        <td [ngClass]="{'since-inception-nv-results' : (filterBy && filterBy === 'non-vanguard-mutual-funds')}">
          <p class="rps-paragraph-one rps-mark-narrow" *ngIf="fund.profile?.isETF" data-rpa-tag-id="inceptionPercentage">
            {{fund.monthEndAvgAnnualRtn?.marketPriceFundReturn?.sinceInceptionPct| percentParser}}
          </p>
          <p class="rps-paragraph-one rps-mark-narrow" *ngIf="fund.profile?.isMutualFund || fund.profile?.is529" data-rpa-tag-id="inceptionPercentage">
            {{fund.monthEndAvgAnnualRtn?.fundReturn?.sinceInceptionPct| percentParser}}
          </p>
          <p *ngIf="fund.monthEndAvgAnnualRtn.sinceInceptionAsOfDate" class="rps-paragraph-three rps-mark-narrow" data-rpa-tag-id="inceptionDate">
            ({{fund.monthEndAvgAnnualRtn?.sinceInceptionAsOfDate | ESTPipe}})</p>
          <p *ngIf="!fund.monthEndAvgAnnualRtn.sinceInceptionAsOfDate" class="rps-paragraph-three rps-mark-narrow" data-rpa-tag-id="inceptionDate">
            (&mdash;)</p>

        </td>

        <td *ngIf="filterBy && !(filterBy =='non-vanguard-mutual-funds')">
          <!-- if ETF show regular price else if either mf/529 show fund minimum -->
          <!-- if fund minimum number show convert currency else if show fund minimum else - (not exist case show dash) -->
          <p  class="rps-paragraph-one rps-mark-narrow" data-rpa-tag-id="minInvestment">
            {{fund.profile?.isETF ? ((1 |currency:'USD':'symbol':'1.0') || '&mdash;') :
            (fund.profile?.isMutualFund || fund.profile?.is529) ?
            isNumber(fund.minimum.general.initial) ? (fund.minimum.general.initial|numberSuffix: 2) :
            (fund.minimum.general.initial ? (fund.minimum.general.initial|numberSuffix: 2) : '&mdash;') : '&mdash;'}}
          </p>
        </td>

        <td *ngIf="filterBy && !(filterBy =='529-portfolios')">
          <p class="rps-paragraph-one rps-mark-narrow" *ngIf="(fund.profile?.isMutualFund || fund.profile?.isETF) && !switchModel" data-rpa-tag-id="priceNAV">
            {{fund.dailyPrice?.regular?.price ? (fund.dailyPrice?.regular?.price| currency:'USD':'symbol':'1.2-2') :
            '&mdash;'}}
          </p>
          <p class="rps-paragraph-one rps-mark-narrow" *ngIf="fund.profile?.isETF && switchModel" data-rpa-tag-id="priceMarket">
            {{fund.dailyPrice?.market?.price ? (fund.dailyPrice?.market?.price| currency:'USD':'symbol':'1.2-2') :
            '&mdash;'}}
          </p>
          <p class="rps-paragraph-one rps-mark-narrow" *ngIf="(fund.profile?.isMutualFund && switchModel) || fund.profile?.is529">
            {{'&mdash;'}}
          </p>
        </td>
        <td *ngIf="!(fund.profile?.isMutualFund || fund.profile?.isETF)">
          <p class="rps-paragraph-one rps-mark-narrow" data-rpa-tag-id="priceNAV">
            {{fund.profile?.is529 ?
            (fund.dailyPrice?.regular?.price ? (fund.dailyPrice?.regular?.price| currency:'USD':'symbol':'1.2-2') :
            '&mdash;')
            : (fund.profile?.isMutualFund || fund.profile?.isETF) ? '&mdash;' : '&mdash;'}}
          </p>
        </td>
        <td [ngClass]="{'pricechange-nvmf-results' : (filterBy && filterBy === 'non-vanguard-mutual-funds')}" style="white-space:nowrap;">
          <div *ngIf="!switchModel" class="price-change-container">
            <div class="price-change-icon-and-value-row">
              <c11n-icon class="price-icon-position" *ngIf="fund.dailyPrice?.regular?.priceChangeAmount > 0" [name]="'positive-change'" [size]="'small'" [altText]="'positive change'"></c11n-icon>
              <c11n-icon class="price-icon-position" *ngIf="fund.dailyPrice?.regular?.priceChangeAmount < 0" [name]="'negative-change'" [size]="'small'" [altText]="'negative change'"></c11n-icon>
              <span data-rpa-tag-id="priceChangeNAV">
                {{fund.dailyPrice?.regular?.price ? (fund.dailyPrice?.regular?.priceChangeAmount|
                  currency:'USD':'symbol':'1.2-2') : '&mdash;'}}
              </span>
            </div>
            <span data-rpa-tag-id="pricePercentNAV">
              ({{fund.dailyPrice?.regular?.priceChangePct}}{{fund.dailyPrice?.regular?.priceChangePct?'%':'&mdash;'}})
            </span>
          </div>
          <div *ngIf="fund.profile?.isETF && switchModel"  class="price-change-container">
            <div class="price-change-icon-and-value-row">
              <c11n-icon class="plan-icon-position" *ngIf="fund.dailyPrice?.regular?.priceChangeAmount > 0" [name]="'positive-change'" [size]="'small'" [altText]="'positive change'"></c11n-icon>
              <c11n-icon class="plan-icon-position" *ngIf="fund.dailyPrice?.regular?.priceChangeAmount < 0" [name]="'negative-change'" [size]="'small'" [altText]="'negative change'"></c11n-icon>
              <span data-rpa-tag-id="priceChangeMarket">
                {{fund.dailyPrice?.market?.price ? (fund.dailyPrice?.market?.priceChangeAmount| currency:'USD':'symbol':'1.2-2')
              : '&mdash;'}}
              </span>
            </div>
            <span data-rpa-tag-id="pricePercentMarket">
              ({{fund.dailyPrice?.market?.priceChangePct}}{{fund.dailyPrice?.market?.priceChangePct?'%':'&mdash;'}})
            </span>
          </div>
          <p class="rps-paragraph-one rps-mark-narrow" *ngIf="fund.profile?.isMutualFund && switchModel">
            <span data-rpa-tag-id="priceChangeMarket">
              &mdash;
            </span>
            <br>
            <span data-rpa-tag-id="pricePercentMarket">
              (&mdash;)
            </span>
          </p>
          <div *ngIf="fund.profile?.is529 && switchModel" class="price-change-container">
            <div class="price-change-icon-and-value-row">
              <c11n-icon class="plan-icon-position" *ngIf="fund.dailyPrice?.regular?.priceChangeAmount > 0" [name]="'positive-change'" [size]="'small'" [altText]="'positive change'"></c11n-icon>
              <c11n-icon class="plan-icon-position" *ngIf="fund.dailyPrice?.regular?.priceChangeAmount < 0" [name]="'negative-change'" [size]="'small'" [altText]="'negative change'"></c11n-icon>
              <span data-rpa-tag-id="priceChangeNAV">
                {{fund.dailyPrice?.regular?.price ? (fund.dailyPrice?.regular?.priceChangeAmount|
                  currency:'USD':'symbol':'1.2-2') : '&mdash;'}}
              </span>
            </div>
            <span data-rpa-tag-id="priceChangeNAV">
              ({{fund.dailyPrice?.regular?.priceChangePct}}{{fund.dailyPrice?.regular?.priceChangePct?'%':'&mdash;'}})
            </span>
          </div>
        </td>

  </tr>
</ng-template>

<ng-template #loading>
    <tr>
        <th class="detail-view-loading" colspan="100%">
          <div class="spinner-container">
            <c11n-spinner size="medium" colorMode="on-light" spinnerStatus="Loading..."></c11n-spinner>
          </div>
            <p class="rps-paragraph-one no-results">Loading...</p>
        </th>
    </tr>
</ng-template>

<ng-template #noData>
    <tr>
        <th colspan="100%">
            <p class="rps-paragraph-one rps-mark-bold no-results">There are no funds to display based upon your filter criteria</p>
        </th>
    </tr>
</ng-template>

<c11n-modal-dialog
  modalId="detailViewModal"
  [headingText]="dialogTitle"
  #detailViewModalDialog
>
  <div c11n-modal-dialog-body>
    <p class="rps-paragraph-one" [innerHTML]="formatLink(noteText)" attr.data-aem-source="{{noteTextAem?.isAEM | json}}"></p>
  </div>
</c11n-modal-dialog>
